export const DASH_SLASH = '— / —';
export const DOUBLE_DASH = '--';
export const SINGLE_DASH = '\u2014';
